import { send } from "../index";

export function saveMode(data, opts = {}) {
	//  设置预存模式
	return send({
		url: "/admin/preStoreCenter/save.do",
		method: "POST",
		data,
		...opts,
	});
}

export function getSettingDetail(data, opts = {}) {
	//  预存模式设置详情
	return send({
		url: "/admin/preStoreCenter/settingDetail.do",
		method: "POST",
		data,
		...opts,
	});
}


export function getFundCinemaList(data, opts = {}) {
	//  预存影院配置列表
	return send({
		url: "/admin/preStoreCenter/searchList.do",
		method: "POST",
		data,
		...opts,
	});
}

export function getCinemaDetail(data, opts = {}) {
	//  预存影院配置详情
	return send({
		url: "/admin/preStoreCenter/detail.do",
		method: "POST",
		data,
		...opts,
	});
}

export function updateCinemaDetail(data, opts = {}) {
	//  预存影院配置修改
	return send({
		url: "/admin/preStoreCenter/update.do",
		method: "POST",
		data,
		...opts,
	});
}

export function setIsDisabled(data, opts = {}) {
	//  预存影院配置启用禁用
	return send({
		url: "/admin/preStoreCenter/setIsDisabled.do",
		method: "POST",
		data,
		...opts,
	});
}

export function recharge(data, opts = {}) {
	//  预存影院配置充值
	return send({
		url: "/admin/preStoreCenter/recharge.do",
		method: "POST",
		data,
		...opts,
	});
}

export function getRechargeList(data, opts = {}) {
	//  预存充值记录
	return send({
		url: "/admin/preStoreRecord/searchList.do",
		method: "POST",
		data,
		...opts,
	});
}

export function getPreStoreStatistics(data, opts = {}) {
	//  余额变动记录
	return send({
		url: "/admin/preStoreStatistics/searchList.do",
		method: "POST",
		data,
		...opts,
	});
}

export function savePreStoreStatistics(data, opts = {}) {
	//  刷新今日数据
	return send({
		url: "/admin/preStoreStatistics/savePreStoreStatistics.do",
		method: "POST",
		data,
		...opts,
	});
}

export function getTicketOrderList(data, opts = {}) {
	//  预存变动明细
	return send({
		url: "/admin/preStoreStatistics/orderRecordList.do",
		method: "POST",
		data,
		...opts,
	});
}
